export default __webpack_public_path__ + "static/media/video.52e8933b.mp4";